import { CONSTANTS_GENERATION__slider_step } from '@shared/constants/CONSTANTS_GENERATION__slider_step';
import { FIELD_PRIMITIVE__float } from '@shared/dto/generation/graph_invoke/_fields/_primitives/number/FIELD_PRIMITIVE__float';
import { DTO__number_range } from '@shared/dto/generation/settings/DTO__number_range';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__image_asset_category } from '../../../../_fields/ENUM__image_asset_category';
import { FIELD__image_asset } from '../../../../_fields/image/FIELD__image_asset';
import { ENUM__invocation_type } from '../../../_base/ENUM__invocation_type';
import { INVOCATION_VISION__base_cv2 } from '../../_base/INVOCATION_VISION__base_cv2';

export class INVOCATION_VISION_CV2__control_line_guidance_canny_semi_auto extends INVOCATION_VISION__base_cv2 {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.INVOCATION_VISION_CV2__LINE__CANNY_SEMI_AUTO;

  /*
   * FIELDS
   */
  @FIELD__image_asset.init_as_input({ category: ENUM__image_asset_category.IMAGE }, { field_role: '🖼️ Image' })
  image!: FIELD__image_asset;

  @FIELD_PRIMITIVE__float.init_as_input(
    {
      value: 0.5,
      //
      slider_step: CONSTANTS_GENERATION__slider_step.WEIGHT_DEFAULT,
      slider_step_values: CONSTANTS_GENERATION__slider_step.WEIGHT_VALUES,
      //
      values_allowed: new DTO__number_range(0.0, 1.0),
      value_range: new DTO__number_range(0.0, 1.0),
    },
    { field_role: '🎚️ Detalization' },
  )
  detalization!: FIELD_PRIMITIVE__float;

  /*
   * OUTPUT
   */

  @FIELD__image_asset.init_as_output({ category: ENUM__image_asset_category.LINE__CANNY })
  out!: FIELD__image_asset;

  /*
   * METHODS
   */

  constructor() {
    super(ENUM__invocation_type.VISION_CV2__LINE__CANNY_SEMI_AUTO);
  }
}
